import {wdiCore} from "@/components/WdiControls";

const idsSplit = (productIds?: string | null) => {
  const ids: string[] = [];
  if (productIds) {
    productIds.split(',').forEach((item) => {
      if (!wdiCore.String.IsNullOrEmpty(item.trim())) {
        ids.push(item.trim());
      }
    });
  }
  return ids;
};

const isDupProduct = (first: string | undefined, second: string | undefined) => {
  if (wdiCore.String.IsNullOrEmpty(first) || wdiCore.String.IsNullOrEmpty(first)) {
    return true;
  }
  const firstIdSet: string[] = idsSplit(first);
  const secondIdSet: string[] = idsSplit(second);
  let isDup = false;
  firstIdSet.forEach((item) => {
    if (secondIdSet.includes(item)) {
      isDup = true;
    }
  });
  return isDup;
};

const isDupTerms = (first: API.SalesContractTermsVo, second: API.SalesContractTermsVo) => {
  // 处理方式不一致 或者 费用项不一致 明细不重复
  if (first.processMode != second.processMode || first.ecId != second.ecId) {
    return false;
  }
  return isDupProduct(first.productIdsRebate, second.productIdsRebate);
};

export const isDupSalesContractTerms = (
  dataSource: API.SalesContractTermsVo[],
  current: API.SalesContractTermsVo,
  rowIndex: number,
) => {
  let isDup = false;
  dataSource?.forEach((item, itemIndex) => {
    if (itemIndex != rowIndex && isDupTerms(item, current)) {
      isDup = true;
    }
    return !isDup;
  });
  return isDup;
};
